
$('#contactForm').validate({
  lang: 'fr',
  rules: {
    nom: {
      required: true,
    },
    classe: {
      required: true,
    },
    email: {
      required: true,
      email: true,
    },
    telephone: {
      required: true,
    },
    objet:{
      required:true,
    },
    message: {
      required: true,
    },
  },
  messages: {
    nom: 'Saisir votre nom',
    classe: 'Saisir votre prénom',
    email: {
      required: 'Saisir votre adresse email',
      email: 'Saisir une adresse email valide (ex: email@exemple.com)',
    },
    telephone: 'Saisir votre numéro de téléphone',
    objet: 'Saisir l\'objet devotre message',
    message: 'Saisir votre message',
  },
  errorElement : 'div',
  errorPlacement: function(error, element) {
    var placement = $(element).data('error');
    if (placement) {
      $(placement).append(error);
    } else {
      error.insertAfter(element);
    }
  },
});

$('#contactForm').submit(function() {
  var form = $(this);
  if(form.valid()) {
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_object.ajaxurl,
      type: 'POST',
      data: form.serialize(),
      success: function( response ){
        if(response == 'success') {
          $('#result-msg').html('<p>Merci, votre demande a bien été envoyée ! Nous allons la traiter dans les meilleurs délais.</p>').fadeIn(1000);
          $('#result-msg').removeClass('error');
          $('#result-msg').addClass('success');
        }else {
          $('#result-msg').html('<p>Oops! Une erreur est survenue lors de l’envoi du message. Merci de réessayer.</p>').fadeIn(1000);
          $('#result-msg').removeClass('success');
          $('#result-msg').addClass('error');
        }
      },
    });
  }else {
    $('#result-msg').html('<p>Oops! Veuillez remplir les champs.</p>').fadeIn(1000);
    $('#result-msg').removeClass('success');
    $('#result-msg').addClass('error');
  }
  return false;
});



// WEBPACK FOOTER //
// ./scripts/contact.js